module.exports = __webpack_public_path__ + "static/img/alpabern.d515fe7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logos/alpabern.png
// module id = 475
// module chunks = 1